import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-eye-open",
  "use": "icon-eye-open-usage",
  "viewBox": "0 0 1027 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1027 1024\" id=\"icon-eye-open\"><defs><style type=\"text/css\"></style></defs><path d=\"M483.52 256C138.24 256 6.528 530.56 6.528 530.56l-6.528 13.44 6.528 13.44S138.24 832 483.52 832c345.28 0 476.992-274.56 476.992-274.56l6.272-13.44-6.272-13.44S828.8 256 483.52 256z m0 64C607.552 320 707.52 420.032 707.52 544c0 124.032-100.032 224-224 224A223.616 223.616 0 0 1 259.52 544C259.52 419.968 359.552 320 483.52 320z m-227.776 49.728A284.992 284.992 0 0 0 195.52 544c0 65.728 23.04 125.76 60.224 174.272-122.752-60.992-172.736-158.08-180.736-174.272 8-16.256 57.984-113.28 180.736-174.272z m455.552 0c122.752 60.992 172.736 158.08 180.736 174.272-8 16.256-57.984 113.28-180.736 174.272A284.992 284.992 0 0 0 771.52 544c0-65.728-23.04-125.76-60.224-174.272zM483.52 448a96 96 0 1 0 0 192 96 96 0 0 0 0-192z\" fill=\"\" p-id=\"4484\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/eye-open.svg
// module id = no6o
// module chunks = 47